<script setup>
import CalculatorParam from './CalculatorParam.vue';
import ProgramSelect from './ProgramSelect.vue';
</script>

<template>
  <CalculatorParam>
    <template #title>
      {{ $Bitrix.Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_PROGRAM') }}
    </template>
    <ProgramSelect/>
  </CalculatorParam>
</template>
